<template>
  <div class="row pricing-table-two">
    <div
      class="col-md-6 col-lg-4 pricing-table pricing-table--popular wow move-up"
      v-for="(pricing, index) in pricingTable"
      :key="index"
    >
      <div class="pricing-table__inner">
        <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
          <span>Popular Choice</span>
        </div>
        <div class="pricing-table__header">
          <!--
          <div class="pricing-table__image">
            <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt" />
          </div>
          -->
          <h5 class="pricing-table__title">{{ pricing.title }}</h5>
          <div class="pricing-table__price-wrap">
            <h6 class="price" v-if="pricing">€{{ pricing.value }}</h6>
          </div>
          <p class="pricing-table__title pt-3">
            <span v-if="pricing.perMonth">per month</span>
          </p>
        </div>
        <div class="pricing-table__body">
          <div class="pricing-table__footer">
            <router-link
              :to="{ path: '/go' }"
              class="btn btn--green signup"
              :class="{ 'btn--green': pricing.active }"
              >Get started</router-link
            >
            <!--
            <button
              class="ht-btn ht-btn-default"
              :class="{'btn--green': pricing.active}"
            >Get started</button>
            -->
          </div>
          <ul class="pricing-table__list text-left">
            <li v-for="(list, index) in pricing.content" :key="index">
              {{ list }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pricingTwo",
  data() {
    return {
      pricingTable: [
        {
          stripeId: "prod_HuZJX2U2p8MB6v",
          title: "Free",
          value: "0",
          alt: "Pricing Thumb",
          isPopular: false,
          active: false,
          perMonth: false,
          content: [
            "3 products",
            "1 document template",
            "1 workspace",
            "1 user",
          ],
        },
        {
          stripeId: "prod_HuaQz1wZkJtXHK",
          title: "Enhanced",
          value: "290",
          alt: "Pricing Thumb",
          isPopular: false,
          active: true,
          perMonth: true,
          content: [
            "30 products",
            "3 document templates",
            "2 workspaces",
            "3 users",
          ],
        },
        {
          stripeId: "prod_HuaTGA5Qni6i5P",
          title: "Unlimited",
          value: "490",
          alt: "Pricing Thumb",
          isPopular: false,
          active: false,
          perMonth: true,
          content: [
            "Unlimited products",
            "Unlimited document templates",
            "Unlimited workspaces",
            "Unlimited users",
          ],
        },
      ],
      currency: "eur",
      pricing: null,
    };
  },
  mounted() {
    //this.getPricing();
  },
  methods: {
    getPricing() {
      this.$pricingService.getProducts().then((res) => {
        this.pricing = res;
      });
    },
  },
};
</script>